import Brands1 from "../assets/img/brands/brand-logo1.png";
import Brands2 from "../assets/img/brands/brand-logo2.png";
import Brands3 from "../assets/img/brands/brand-logo3.png";
import Brands4 from "../assets/img/brands/brand-logo4.png";
import Brands5 from "../assets/img/brands/brand-logo5.png";
import Brands6 from "../assets/img/brands/brand-logo6.png";

export const BrandList = [
    {
        img: Brands1
    },
    {
        img: Brands2
    },
    {
        img: Brands3
    },
    {
        img: Brands4
    },
    {
        img: Brands5
    },
    {
        img: Brands6
    },
]